import type { TranslationKey } from '../../i18n/useTranslation';

export interface SidebarEntry {
  id: string;
  labelKey: TranslationKey;
  children?: { id: string; labelKey: TranslationKey }[];
}

export const GUIDE_SECTIONS: SidebarEntry[] = [
  {
    id: 'upload-flight-data',
    labelKey: 'guide.sections.uploadFlightData',
  },
  {
    id: 'share-flights',
    labelKey: 'guide.sections.shareFlights',
  },
  {
    id: 'maintenance-records',
    labelKey: 'guide.sections.maintenanceRecords',
    children: [
      { id: 'maintenance-creating', labelKey: 'guide.sections.maintenanceRecordsCreating' },
      { id: 'maintenance-quality', labelKey: 'guide.sections.maintenanceRecordsQuality' },
      { id: 'maintenance-schedules', labelKey: 'guide.sections.maintenanceRecordsSchedules' },
    ],
  },
  {
    id: 'health-panel',
    labelKey: 'guide.sections.healthPanel',
    children: [
      { id: 'health-avgr', labelKey: 'guide.sections.healthPanelAvgr' },
      { id: 'health-avgt', labelKey: 'guide.sections.healthPanelAvgt' },
      { id: 'health-tuwt', labelKey: 'guide.sections.healthPanelTuwt' },
      { id: 'health-action', labelKey: 'guide.sections.healthPanelAction' },
    ],
  },
  {
    id: 'drone-notes',
    labelKey: 'guide.sections.droneNotes',
    children: [
      { id: 'notes-creating', labelKey: 'guide.sections.droneNotesCreating' },
      { id: 'notes-filters', labelKey: 'guide.sections.droneNotesFilters' },
      { id: 'notes-timeline', labelKey: 'guide.sections.droneNotesTimeline' },
    ],
  },
  {
    id: 'llm-chat',
    labelKey: 'guide.sections.llmChat',
    children: [
      { id: 'llm-sql', labelKey: 'guide.sections.llmChatSql' },
      { id: 'llm-maintenance', labelKey: 'guide.sections.llmChatMaintenance' },
      { id: 'llm-tips', labelKey: 'guide.sections.llmChatTips' },
    ],
  },
  {
    id: 'invite-users',
    labelKey: 'guide.sections.inviteUsers',
  },
];

/** Flat list of all section and subsection IDs, derived from GUIDE_SECTIONS. */
export const ALL_SECTION_IDS: string[] = GUIDE_SECTIONS.flatMap((section) => [
  section.id,
  ...(section.children?.map((child) => child.id) ?? []),
]);
